/**
 * Dashboard routes.
 *
 * Private, unlike the self-serve flow: this is a customer-facing surface for
 * signed-in hiring teams, so it is wrapped in PrivateRoute at the app level
 * alongside jobs, users and calendar.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAccount } from '../../context/account.context';
import { UserRole } from '../users/utils/role';
import Dashboard from './pages/dashboard';
import HiringManagerDashboard from './pages/hiring-manager-dashboard';

const DashboardRoutes = () => {
  const { user } = useAccount();
  // Same landing route for every role -- the nav item and the `/` redirect
  // are both unconditional. A Hiring Manager gets the narrower, queue-first
  // page here rather than a second, competing "dashboard" destination.
  const DashboardForRole =
    user?.role === UserRole.HIRING_MANAGER ? HiringManagerDashboard : Dashboard;
  return (
    <Routes>
      <Route path="/" element={<DashboardForRole user={user} />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default DashboardRoutes;
